
// import '@/assets/scss/index.scss'
import _, { throttle } from 'lodash'
import { backScrollPosMixin } from '~/mixin/common/scroll/backScrollPosMixin'
import Topbaner from '@/components/common/Topbaner.vue'
import HeaderCmp from '@/components/common/Header.vue'
import MainSkeleton from '~/components/ds/skeletonUnit/MainSkeleton.vue'
import ExbtSkeleton from '~/components/ds/skeletonUnit/ExbtSkeleton.vue'
import DiySkeleton from '~/components/ds/skeletonUnit/DiySkeleton.vue'
import Diy2BannerSkeleton from '~/components/ds/skeletonUnit/Diy2BannerSkeleton.vue'
import OrderPageSkeleton from '~/components/ds/skeletonUnit/OrderPageSkeleton.vue'
import Footer from '@/components/common/footer.vue'
import QuiEl from '@/components/common/QuiEl.vue'
import SCR_MBC_0115_01 from '@/pages/mb/mbc/SCR_MBC_0115_01.vue'
import LoadingBar from '~/components/common/LoadingBar'
import * as ds from '~/scriptData/ds/dsCommon.js'
import { setHolidayDeliveryFlag } from '~/scriptData/ds/dsCommon.js'
import { checkMountedPath, useKeepAliveComponents } from '~/scriptData/common/routes/backRoutes'
import { createPopupScrollLock } from '~/scriptData/common/popupScrollLock'

export default {
  name: 'DsMainLayout',
  components: {
    ExbtSkeleton,
    Topbaner,
    HeaderCmp,
    Footer,
    QuiEl,
    SCR_MBC_0115_01,
    LoadingBar,
    MainSkeleton,
    DiySkeleton,
    Diy2BannerSkeleton,
    OrderPageSkeleton
  },
  mixins: [backScrollPosMixin],
  provide () {
    return {
      sendPageName: this.sendPageName
    }
  },
  asyncData () {},
  fetchOnServer: false,
  data () {
    return {
      searchTerm: '',
      showTopBanner: false,
      topBannerId: '',
      bannerAccounts: [],
      openBanner: false,
      recentlyProducts: [],
      mainLogo: {}, // 메인 로고
      pageName: '',
      currentUrl: '',
      scrollY: null, // scrollTop
      headerSm: false, // 헤더 변환 여부
      headerAniEnd: false,
      stickyStatus: [ // sticky 상태 제어 (sticky 항목 최대 2개 예상)
        { position: 0, fix: false },
        { position: 0, fix: false },
        { position: 0, fix: false }
      ],
      includeUrlData: useKeepAliveComponents,

      // 공용 QuiEl 비표시 대상 페이지 (ug 콘텐츠 페이지 제거로 현재 비어있음)
      quiElExceptUrl: [],
      quickOn: false,
      popupScrollLock: null,
      showLoadingbar: false,
      isLoading: true,
      isCompletePageMount: false,
      isIncludeCheckMounted: false,
      isPdLazyComplete: false
    }
  },
  fetch () {
    this.loadMainLogo()
  },
  head () {
    const meta = this.$store.getters['seoMeta/getMeta']
    if (!meta.title) { return {} }
    const head = {
      title: meta.title,
      meta: [
        { hid: 'description', name: 'description', content: meta.description },
        { hid: 'og:title', property: 'og:title', content: meta.title },
        { hid: 'og:description', property: 'og:description', content: meta.description },
        { hid: 'og:url', property: 'og:url', content: meta.ogUrl },
        { hid: 'og:image', property: 'og:image', content: meta.ogImage },
        { hid: 'og:type', property: 'og:type', content: meta.ogType }
      ],
      link: [],
      script: []
    }
    if (meta.canonical) {
      head.link.push({ rel: 'canonical', href: meta.canonical })
    }
    if (meta.mobileUrl) {
      head.link.push({ rel: 'alternate', media: 'only screen and (max-width: 640px)', href: meta.mobileUrl })
    }
    if (meta.jsonLd && meta.jsonLd.length) {
      meta.jsonLd.forEach((ld, i) => {
        head.script.push({ hid: `json-ld-seo-${i}`, type: 'application/ld+json', json: ld })
      })
    }
    return head
  },
  computed: {
    isPdDetailLoading () {
      // [2026-05-28] 상품상세: 페이지 끝에 도달하기 전까지 footer 숨김
      if (this.$route.path.includes('/pd/pdr/SCR_PDR_0001')) {
        return !this.isPdLazyComplete
      }
      return false
    },
    getMinHeight () {
      if (this.$store.getters['page/getPopstate'] && this.scrollHeight > 0 && this.scrollHeight !== undefined) {
        return this.scrollHeight + 'px'
      } else if (this.$route.path.includes('/spexhbt')) {
        return 750
      } else { return '' }
    },
  },
  watch: {
    $route: {
      handler (value) {
        // 팝업이 열린 상태에서 페이지 전환 시: MutationObserver의 스크롤 복원이 실행되기 전에
        // 팝업 overflow 상태를 먼저 정리하여 불필요한 window.scrollTo 호출 방지
        this.popupScrollLock?.reset()
        this.initCompleteValue()
        setHolidayDeliveryFlag(value.path, this.$store, this.$api)

        console.log('레이아웃에서 라우트 변경감지', this.$route)
        this.currentUrl = this.$route.path
        this.showLoadingbar = !this.currentUrl.includes('ds') && !this.currentUrl.includes('/pd/pdr/SCR_PDR_0001')
        this.handleTopBanner()
        if (sessionStorage.getItem('filterCheck') !== '' && sessionStorage.getItem('filterCheck') !== null && sessionStorage.getItem('filterCheck') !== sessionStorage.getItem('preFilterCheck')) {
          sessionStorage.setItem('preFilterCheck', sessionStorage.getItem('filterCheck'))
        }
        if (this.$nuxt.context.from.path.includes('/pd/pdr/SCR_PDR_0001')) {
          sessionStorage.setItem('preFilterCheck', [])
        }
        if (this.$nuxt.context.from.path.includes('/ds/recmd/C206') || this.$nuxt.context.from.path.includes('/ds/dsBrand/C212')) {
          const preFilterCheck = sessionStorage.getItem('preFilterCheck') || []
          // if (preFilterCheck === null) {
          //   preFilterCheck = []
          // }
          sessionStorage.setItem('filterCheck', preFilterCheck)
        }
        // params 에 openTransfPopup 이 true 라면 베송지 설정을 연다
        /*
        if (this.$route.params.openTransfPopup) {
          console.log('배송지 설정 팝업 바로오픈')
          this.$nextTick(() => {
            this.openTransf(true)
          })
        }
        */
      }
    }
  },
  created () {
    this.$nuxt.$on('page-mounted', () => {
      this.isCompletePageMount = true
    })
    this.$nuxt.$on('pd-lazy-complete', () => {
      this.isPdLazyComplete = true
    })
    this.$nuxt.$on('pd-lazy-hide', () => {
      this.isPdLazyComplete = false
    })
    this.initCompleteValue()
    setHolidayDeliveryFlag(this.$route.path, this.$store, this.$api)
    this.$nuxt.$on('eb-scroll-top', this.goScrollTop)
    this.$nuxt.$on('changeHeaderSearchInput', this.changeHeaderSearchInput)
    this.$nuxt.$on('openTransfPopup', this.openTransf)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleThrottledScroll)
    this.popupScrollLock?.destroy()
    this.$nuxt.$off('eb-scroll-top')
    this.$nuxt.$off('changeHeaderSearchInput')
    this.$nuxt.$off('openTransfPopup')
    this.$nuxt.$off('page-mounted')
    this.$nuxt.$off('pd-lazy-complete')
    this.$nuxt.$off('pd-lazy-hide')
  },
  beforeMount () {
    window.addEventListener('scroll', this.handleThrottledScroll)
    this.handleObserver()
  },
  async mounted () {
    if (!localStorage.getItem('api_v2')) {
      localStorage.setItem('api_v2', 'true')
    }

    // console.log('kakao call start')
    try { window.kakaoPixel('7573203864979226263').pageView() } catch (e) {}
    // console.log('kakao call end')
    this.currentUrl = this.$route.path
    this.handleTopBanner()
    // GNB 메뉴 리스트 로드 (레이아웃 레벨에서 먼저 로드)
    await this.getGnbMenuList()
    this.$nextTick(() => {
      this.isLoading = false
    })
  },
  updated () {
    /*
    console.log('UPDATED????????')
    console.log(this.$route)
    this.$nextTick(() => {
      console.log('UPDATED ---- NEXTTICK', this.$route.meta.scrollPos)
      if (this.$route.meta.scrollPos) {
        this.$refs.scrollArea.scrollTo(this.$route.meta.scrollPos)
      } else {
        this.$refs.scrollArea.scrollTo({ x: 0, y: 0 })
      }
    })
    */
  },
  unmounted () {},
  methods: {
    handleThrottledScroll: throttle(function (e) { this.scrollEvent(e) }, 50),
    handleObserver () {
      this.popupScrollLock = createPopupScrollLock({ document, window })
      this.popupScrollLock.start()
    },
    async loadMainLogo () {
      const mtrlsList = await ds.getAccntList('C225', this.$api)
        .then((accountList) => {
          return ds.getMtrlsList(accountList, this.$api)
        })
      this.mainLogo = mtrlsList.length > 0 ? _.head(_.head(_.head(mtrlsList))?.details) : {}
    },
    scrollEvent () {
      // console.log('------------------------------------------------------')
      // console.log('scrollArea 동작함')
      this.$nextTick(() => {
        const quickEl = this.$refs.quickEl
        this.scrollY = Math.round(window.scrollY)
        this.stickyControl('sticky-cont')
        // 23.08.30 퀵메뉴 show/hide 추가
        if (quickEl !== undefined) {
          this.quickShow()
        }
      })
      // 23.08.30 퀵메뉴 show/hide 추가
    },
    onClickWindow (e) {
      if (e.target.closest('.search-wrap') === null) {
        this.$refs?.header?.searchPopup(e, 'blur')
      } else if (e.relatedTarget !== null && e.relatedTarget.classList.contains('logo')) {
        this.$refs?.header?.searchPopup(e, 'blur')
      }
    },
    goScrollTop () {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    openTransf (isOpen) {
      this.$refs.SCR_MBC_0115_01.outerVisible = isOpen
      this.$refs.SCR_MBC_0115_01.srcComp = 'Header'
    },
    changeHeaderSearchInput (keyword) {
      this.searchTerm = keyword
    },
    sendPageName (pageName) {
      this.pageName = pageName
    },
    stickyControl (itmName) { // sticky 체크
      const stickyCont = document.getElementsByClassName(itmName)

      for (let i = 0; i < stickyCont.length; i++) {
        const stickyContTop = stickyCont[i].getBoundingClientRect().top - this.$refs.header.$el.clientHeight - 16

        if (this.stickyStatus[i] !== undefined) {
          // 하향 스크롤: sticky 활성화 (여유값 추가)
          if (stickyContTop < -10 && this.stickyStatus[i].fix === false) {
            this.stickyStatus[i].position = this.scrollY
            stickyCont[i].classList.add('top-sticky')
            stickyCont[i].parentElement.classList.add('top-sticky-wrap')
            this.stickyStatus[i].fix = true
          } else if (this.stickyStatus[i].position - this.scrollY > 10 && this.stickyStatus[i].fix === true) {
            stickyCont[i].classList.remove('top-sticky')
            stickyCont[i].parentElement.classList.remove('top-sticky-wrap')
            this.stickyStatus[i].fix = false
          }
        } else {
          return
        }
      }
    },
    // 23.08.30 퀵메뉴 show/hide 추가
    quickShow () {
      if (this.scrollY > 100) {
        // prop으로 컨트롤 하게 변경 함
        this.quickOn = true
        // item.classList.add('on')
      } else {
        // item.classList.remove('on')
        this.quickOn = false
      }
    },
    // GNB 상단 띠배너 노출 여부 추가
    async handleTopBanner () {
      const pathName = document.location.pathname.split('/')
      this.bannerAccounts = await ds.getAccntList('C227', this.$api).then((res) => { return res.filter((item) => { return item.aplMdiaPcomYn === 'Y' && item.exhCmptmtTyCd === '07' }) })
      const exhCmptmtId = _.head(this.bannerAccounts)?.exhCmptmtId
      this.topBannerId = exhCmptmtId + '-' + _.head(_.head(this.bannerAccounts)?.mtrls)?.exhMtrlNo
      const cookies = this.$cookiz.get('topAnimation')
      if (this.topBannerId === cookies) {
        this.showTopBanner = false
      } else {
        this.showTopBanner = true
      }
    },
    initCompleteValue () {
      const path = this.$route.path.toLowerCase()
      this.isCompletePageMount = false
      this.isPdLazyComplete = !path.includes('/pd/pdr/scr_pdr_0001')
      this.isIncludeCheckMounted = checkMountedPath.some(element =>
        path === '/ds' ? true : path.includes(element.toLowerCase())
      )
    },
    async getGnbMenuList () {
      const unescapeText = (str) => {
        return _.unescape(str)
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      }

      const cnrList = await this.$AxiosBuilderPostCache
        .data({ exhCnrId: 'C1' })
        .build(24 * 60 * 60 * 1000) // 24시간 캐시
        .post('/ds/cnr/selCnrList')
        .then((res) => {
          const data = res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
          window.localStorage.setItem('corner-list', JSON.stringify(data))
          return data.map((item) => {
            if (item.pcomImgAtchFileUrl) {
              return {
                id: item.exhCnrId,
                name: unescapeText(item.iconRplcTextNm),
                nameColor: item.exhCnrNmColorCd,
                img: item.pcomImgAtchFileUrl,
                alt: item.pcomImgOrglFileNm,
                link: item.pcScrUrl,
                subExhCnrList: item.subExhCnrList?.map((subItem) => {
                  return {
                    id: subItem.exhCnrId,
                    name: unescapeText(subItem.exhCnrNm),
                    linkUrl: subItem.pcScrUrl,
                    imgUrl: subItem.pcomImgAtchFileUrl,
                  }
                })
              }
            } else {
              return {
                id: item.exhCnrId,
                name: unescapeText(item.iconRplcTextNm),
                nameColor: item.exhCnrNmColorCd,
                link: item.pcScrUrl,
                subExhCnrList: item.subExhCnrList?.map((subItem) => {
                  return {
                    id: subItem.exhCnrId,
                    name: unescapeText(subItem.exhCnrNm),
                    linkUrl: subItem.pcScrUrl,
                    imgUrl: subItem.pcomImgAtchFileUrl,
                  }
                })
              }
            }
          })
        })
        .catch((e) => {
          console.error('getGnbMenuList error:', e)
          return []
        })

      if (cnrList && cnrList.length > 0) {
        this.$store.commit('local/setGnbMenuList', JSON.parse(JSON.stringify(cnrList)))
      }
    }
  }
}
